import { SvgIconProps } from '@mui/material';
import { FC } from 'react';

import {
  CarIcon,
  ClockIcon,
  HomeIcon,
  LocationCurrentIcon,
  OfficeIcon,
  PinIcon,
  PlaneIcon,
  TruckIcon,
} from '@abg/kit-base';
import { LocationSuggestion } from '@abg/typings';

import { getFormattedValueByLocationSiteType } from '../../location-suggestion.utils';

import { getIconStyle } from './location-icon.styling';
import { LocationIconProperties } from './location-icon.types';

type IconMapping = Record<
  LocationSuggestion['suggestionTypeCode'],
  React.ComponentType<SvgIconProps> | null
>;

const LOCATION_ICONS: IconMapping = {
  CURRENT: LocationCurrentIcon,
  CURRENT_RESERVATION: LocationCurrentIcon,
  RECENT: ClockIcon,
  'OTR-CITY': OfficeIcon,
  CITY_DOWNTOWN: OfficeIcon,
  'OTR-POINT_OF_INTEREST': PinIcon,
  'ABG-AIRPORT': PlaneIcon,
  AIRPORT: PlaneIcon,
  OTHER: null,
  RAILWAY_BUS_STATION: null,
  TRUCK: TruckIcon,
  'ABG-TRUCK': TruckIcon,
  NEIGHBOURHOOD: null,
  'NO-MATCH': null,
  SAVED: null,
  'ABG-NEIGHBOURHOOD': null,
  'ABG-AVIS-FIRST-DELIVERY': HomeIcon,
};

export const LocationIcon: FC<LocationIconProperties> = ({
  location,
  defaultIcon = CarIcon,
  mode,
}) => {
  const resolveIcon = (iconMapping: IconMapping): React.ElementType => {
    if (!location) return defaultIcon;

    let { suggestionTypeCode: code } =
      getFormattedValueByLocationSiteType(location);

    // Handle inconsistencies in /geo API response: ARGWE-4400
    if (!iconMapping[code]) {
      const fallbackKey = Object.keys(iconMapping).find((key) =>
        key.includes(code),
      );
      if (fallbackKey) {
        code = fallbackKey as LocationSuggestion['suggestionTypeCode'];
      }
    }

    return iconMapping[code] || defaultIcon;
  };

  const IconComponent = resolveIcon(LOCATION_ICONS);

  const styles = getIconStyle(mode);

  return <IconComponent sx={styles} data-testid="location-icon" />;
};
